export default __webpack_public_path__ + "static/media/naturales.88ffa466.png";